import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import css from './InlineLink.module.scss';

export interface ButtonLinkProps extends React.ComponentPropsWithoutRef<'span'> {
  /**
   * Use `inverse` on a dark background.
   */
  variant?: 'inverse';
  to?: never;
  href?: never;
  role?: never;
  onClick?: (e: React.KeyboardEvent<HTMLSpanElement> | React.MouseEvent<HTMLSpanElement>) => void;
}

export const ButtonLink = React.forwardRef<HTMLElement, ButtonLinkProps>(
  ({ variant, ...props }, ref) => (
    <span
      data-component="ButtonLink"
      ref={ref}
      className={classNames(css.link, { [css.inverse]: variant === 'inverse' })}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        props.onKeyDown?.(e);
        if (e.key === 'Enter' || e.key === ' ') props.onClick?.(e);
      }}
      onClick={props.onClick}
      {...props}
    >
      {props.children}
    </span>
  ),
);

ButtonLink.displayName = 'ButtonLink';
